var map = {
	"./badge-cs.png": 9920,
	"./badge-da.png": 5183,
	"./badge-de.png": 2187,
	"./badge-el.png": 6669,
	"./badge-en.png": 655,
	"./badge-es.png": 6282,
	"./badge-et.png": 53,
	"./badge-fr.png": 3886,
	"./badge-hu.png": 7103,
	"./badge-it.png": 9385,
	"./badge-ja.png": 9569,
	"./badge-ko.png": 5031,
	"./badge-lt.png": 5946,
	"./badge-lv.png": 6840,
	"./badge-nl.png": 6344,
	"./badge-pl.png": 694,
	"./badge-pt.png": 4350,
	"./badge-ro.png": 3703,
	"./badge-sk.png": 5176,
	"./badge-sl.png": 967,
	"./badge-sv.png": 3389,
	"./badge-tr.png": 2788
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6093;